export const city = [
  {
    cityName: "Shillong",
    BoardingPoints: [
      "Umsawli Sports Complex",
      "J.N. Sports Complex",
      "Integrated Multipurpose Indoor Hall (IMIH)",
      "Umtham, Slalom Course (Whitewater Village)",
      "Umaim Lake",
      "Lawsohtun Indoor Hall",
      "SAI Ground",
      "Golf Course",
      "NEIGRIHMS",
      "NEHU Campus",
      "SAI Multipurpose Indoor Hall",
      "Laban Sports Hall",
      "Malki Forest",
    ],
  },
  {
    cityName: "Tura",
    BoardingPoints: [
      "P.A. Sangma Sports Complex",
      "Pa Togan Sports Complex",
    ],
  },
  {
    cityName: "Jowai",
    BoardingPoints: [
      "Wahiajer Sports Complex",
      "Kiang Nangbah Indoor Hall",
    ],
  },
];
